import Notifications from "./Component";
export default Notifications;
